import { render, staticRenderFns } from "./siteHeader.vue?vue&type=template&id=638a2139&scoped=true"
import script from "./siteHeader.vue?vue&type=script&lang=js"
export * from "./siteHeader.vue?vue&type=script&lang=js"
import style0 from "./siteHeader.vue?vue&type=style&index=0&id=638a2139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a2139",
  null
  
)

export default component.exports